<template>
  <div style="padding-left: 5px">
    <v-layout wrap>
      <v-flex xs12 style="text-align: right; margin: 0 14px 30px 0;">
        <component-in-line :pos="content.ORD" />
        <!-- <v-btn
          x-small
          @click="handleAddInLine(content.ORD)"
        >
          <v-icon>mdi-keyboard-return</v-icon><v-icon>mdi-plus</v-icon>{{content.ORD}}
        </v-btn> -->
      </v-flex>
    </v-layout>
    <v-card
      elevation="3"
      style="padding: 0 0 10px 0;margin-bottom: 35px;border: 1px solid #c5c5c5"
    >
      <v-tooltip
        bottom
      >
      <!-- <v-tooltip
        bottom
        :disabled="collapseContent"
      > -->
        <template v-slot:activator="{ on }">
          <v-btn
            name="move"
            :color="collapseContent ? '#c5c5c5' : '#c5c5c580'"
            v-on="on"
            light
            small
            absolute
            top
            right
            fab
            outlined
            :style="{ 'opacity' : collapseContent ? '1' : '0.5'}"
            style="height: 30px;width:30px;top:-15px;left: -15px;background-color:white;"
            @mouseover="collapseContent ? onMoveDisabled(false) : null"
            @mouseout="collapseContent ? onMoveDisabled(true) : null"
          >
          <!-- style="right: 115px;background-color:white;" -->
            <v-icon style="font-size:20px;color: rgb(71, 75, 78);">mdi-cursor-move</v-icon>
          </v-btn>
        </template>
        <span>{{ $t(`menus.info.${collapseContent ? 'moveContent' : 'collapse'}`) }}</span>
      </v-tooltip>
      <!-- <sort-content /> -->
      <v-tooltip bottom v-if="isMoveContent">
        <template v-slot:activator="{ on }">
          <!-- <v-btn color="primary" dark v-on="on">Button</v-btn> -->
          <v-btn
            v-on="on"
            :color="enterpriseColor"
            dark
            small
            absolute
            top
            right
            fab
            :elevation="5"
            style="right: 100px;"
            @click="showMenuList = true"
          >
            <v-icon>mdi-file-move-outline</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('menus.info.moveContent') }}</span>
      </v-tooltip>
      <!-- <v-btn
        :color="enterpriseColor"
        dark
        small
        absolute
        top
        right
        fab
        :elevation="5"
        style="right: 55px;"
        @click="handleCopyContent"
      >
        <v-icon>mdi-content-duplicate</v-icon>
      </v-btn> -->

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <!-- <v-btn color="primary" dark v-on="on">Button</v-btn> -->
          <v-btn
            v-on="on"
            :color="content.HideMobile ? 'red' : enterpriseColor"
            dark
            small
            absolute
            top
            right
            fab
            :elevation="5"
            style="right: 145px;"
            @click="handleHideContent"
          >
            <v-icon>{{ content.HideMobile ? 'mdi-eye-off' : 'mdi-eye' }}</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('menus.info.hideContent') }}</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <!-- <v-btn color="primary" dark v-on="on">Button</v-btn> -->
          <v-btn
            v-on="on"
            :color="enterpriseColor"
            dark
            small
            absolute
            top
            right
            fab
            :elevation="5"
            style="right: 55px;"
            @click="handleCopyContent"
          >
            <v-icon>mdi-content-duplicate</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('menus.info.cloneContent') }}</span>
      </v-tooltip>
      <!-- <v-btn
        color="red"
        dark
        small
        absolute
        top
        right
        fab
        :elevation="5"
        style="right:10px;background-color:white"
        @click="showConfirmDelete=true"
      >
        <v-icon>mdi-delete</v-icon>
      </v-btn> -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <!-- <v-btn color="primary" dark v-on="on">Button</v-btn> -->
          <v-btn
            v-on="on"
            color="red"
            dark
            small
            absolute
            top
            right
            fab
            :elevation="5"
            style="right:10px;background-color:white"
            @click="showConfirmDelete=true"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('menus.info.deleteContent') }}</span>
      </v-tooltip>
      <!-- <div
        class="text-left pt-2"
        style="padding: 10px 10px 0 10px !important;"
      >
        <h5><v-icon>{{ getIcon(content.Type) }}</v-icon> {{ $t(getTitle(content.Type)) }}</h5>
      </div> -->
      <div
        :ref="content.ID"
        style="padding: 0 10px 0 10px !important;"
      >
        <form-title
          v-if="content.Type === 2"
          :content="content"
        />
        <form-space
          v-else-if="content.Type === 3"
          :content="content"
        />
        <form-image
          v-else-if="content.Type === 4"
          :content="content"
        />
        <form-iframe
          v-else-if="content.Type === 5"
          :content="content"
        />
        <form-alert
          v-else-if="content.Type === 6"
          :content="content"
        />
        <form-gallery
          v-else-if="content.Type === 7"
          :content="content"
        />
        <form-video
          v-else-if="content.Type === 8"
          :content="content"
        />
        <form-meteo
          v-else-if="content.Type === 9"
          :content="content"
        />
        <form-map
          v-else-if="content.Type === 10"
          :content="content"
        />
        <form-twitter
          v-else-if="content.Type === 11"
          :content="content"
        />
        <form-facebook
          v-else-if="content.Type === 12"
          :content="content"
        />
        <form-activity
          v-else-if="content.Type === 13"
          :content="content"
        />
        <form-pdf
          v-else-if="content.Type === 14"
          :content="content"
        />
        <form-timeline
          v-else-if="content.Type === 15"
          :content="content"
        />
        <form-text
          v-else-if="content.Type === 16"
          :content="content"
        />
        <form-contact
          v-else-if="content.Type === 17"
          :content="content"
        />
        <form-divider
          v-else-if="content.Type === 18"
          :content="content"
        />
        <form-show
          v-else-if="content.Type === 19"
          :content="content"
        />
        <form-site
          v-else-if="content.Type === 20"
          :content="content"
        />
        <form-agenda
          v-else-if="content.Type === 21"
          :content="content"
        />
        <form-parrilla
          v-else-if="content.Type === 22"
          :content="content"
        />
        <form-wifi
          v-else-if="content.Type === 23"
          :content="content"
        />
        <form-property
          v-else-if="content.Type === 24"
          :content="content"
        />
        <form-commercial
          v-else-if="content.Type === 25"
          :content="content"
        />
        <form-queue
          v-else-if="content.Type === 26"
          :content="content"
        />
        <form-food-drink
          v-else-if="content.Type === 27"
          :content="content"
        />
        <form-link-domain
          v-else-if="content.Type === 28"
          :content="content"
        />
        <form-form
          v-else-if="content.Type === 29"
          :content="content"
        />
        <form-product-service
          v-else-if="content.Type === 30"
          :content="content"
        />
        <form-pdf-translate
          v-else-if="content.Type === 31"
          :content="content"
        />
        <form-link-external
          v-else-if="content.Type === 32"
          :content="content"
        />
        <form-channel-list
          v-else-if="content.Type === 33"
          :content="content"
        />
        <form-activity-acttiv
          v-else-if="content.Type === 34"
          :content="content"
        />
        <form-poll
          v-else-if="content.Type === 35"
          :content="content"
        />
        <form-instagram
          v-else-if="content.Type === 36"
          :content="content"
        />
        <form-icon-list
          v-else-if="content.Type === 37"
          :content="content"
        />
        <form-dropdown-button
          v-else-if="content.Type === 38"
          :content="content"
        />
        <form-dfiles
          v-else-if="content.Type === 39"
          :content="content"
        />

        <form-rcovid
          v-else-if="content.Type === 40"
          :content="content"
        />
        <form-image-translate
          v-else-if="content.Type === 41"
          :content="content"
        />
        <form-iberostar-food
          v-else-if="content.Type === 42"
          :content="content"
        />
        <form-icons
          v-else-if="content.Type === 43"
          :content="content"
        />
        <form-hsconsulting
          v-else-if="content.Type === 44"
          :content="content"
        />
        <form-brochure
          v-else-if="content.Type === 45"
          :content="content"
        />
        <form-infoten
          v-else-if="content.Type === 46"
          :content="content"
        />
        <formCMActivities
          v-else-if="content.Type === 48"
          :content="content"
        />
        <form-49-menu-ext-food
          v-else-if="content.Type === 49"
          :editedItem="content"
          :locale="locale"
        />
        <form50CMAttendance
          v-else-if="content.Type === 50"
          :content="content"
        />
        <form51CMWeeklyMenu
          v-else-if="content.Type === 51"
          :content="content"
        />
        <form54FormCio
          v-else-if="content.Type === 54"
          :content="content"
        />
        <form55DviewcontentMessages
          v-else-if="content.Type === 55"
          :content="content"
        />
        <form56Servatur
          v-else-if="content.Type === 56"
          :content="content"
        />
        <form57InteractiveMaps
          v-else-if="content.Type === 57"
          :content="content"
        />
        <form58AbamaRequestReservation
          v-else-if="content.Type === 58"
          :content="content"
        />
        <availability :data="content" :onChange="handleUpdateAvailability" />
      </div>
    </v-card>
    <confirm-delete 
      :showDialog="showConfirmDelete"
      :onKO="handleCancelDelete"
      :onOK="handleDelete"
    />
    <v-dialog
      v-model="showMenuList"
      max-width="500px"
    >
      <v-card>
        <v-card-title>
          {{ $t('common.selectMenu') }}
        </v-card-title>
        <v-card-text>
          <v-autocomplete
            v-model="menuToMove"
            :label="$t('menus.name')"
            :items="menus"
            item-text="Name"
            item-value="ID"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="secundary"
            @click="showMenuList = false"
          >
            {{$t('common.cancel')}}
          </v-btn>
          <v-btn
            dark
            :color="enterpriseColor"
            @click="handleMoveContent"
          >
            {{$t('common.move')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  // import uuidv1 from 'uuid/v1'
  import _ from 'lodash'
  import utils from '@/services/utils.js'
  import api from '@/services/api'
  // import constants from '@/constants'
  import Availability from '@/components/Availability'
  import FormTitle from './Title'
  import FormSpace from './Space'
  import FormImage from './Image'
  import FormIframe from './Iframe'
  import FormAlert from './Alert'
  import FormVideo from './Video'
  import FormGallery from './gallery/Index'
  import FormMeteo from './Meteo'
  import FormMap from './Map'
  import FormTwitter from './Twitter'
  import FormFacebook from './Facebook'
  import FormActivity from './Activity'
  import FormPdf from './PDF'
  import FormTimeline from './timeline/Index'
  import FormText from './Text'
  import FormContact from './contact/Index'
  import FormDivider from './Divider'
  // import SortContent from './SortContent'
  import FormShow from './Show'
  import FormSite from './Site'
  import FormAgenda from './Agenda'
  import FormParrilla from './Parrilla'
  import FormWifi from './Wifi'
  import FormProperty from './Property'
  import FormCommercial from './Commercial'
  import FormQueue from './Queue'
  import FormFoodDrink from './foodDrink/Index'
  import FormLinkDomain from './LinkDomain'
  import FormForm from './FormForm'
  import FormProductService from './productService/Index'
  import FormPdfTranslate from './PDFTranslate'
  import FormLinkExternal from './LinkExternal'
  import FormChannelList from './ChannelList'
  import FormActivityActtiv from './ActivityActtiv'
  import FormPoll from './poll/Index'
  import FormInstagram from './Instagram'
  import FormIconList from './IconList'
  import FormDropdownButton from './dropdownButton/Index'
  import FormDfiles from './dfiles/Index'
  import FormRcovid from './RCovid'
  import FormImageTranslate from './ImageTranslate'
  import FormIberostarFood from './IberostarFood'
  import FormIcons from './Icons'
  import FormHsconsulting from './Hsconsulting'
  import FormBrochure from './brochure/Index'
  import FormInfoten from './Infoten'
  import FormCMActivities from './Form48CMActivities'
  import Form49MenuExtFood from './Form49MenuExtFood'
  import Form50CMAttendance from './Form50CMAttendance'
  import Form51CMWeeklyMenu from './Form51CMWeeklyMenu'
  import Form54FormCio from './Form54FormCio'
  import Form55DviewcontentMessages from './Form55DviewcontentMessages'
  import Form56Servatur from './Form56Servatur'
  import Form57InteractiveMaps from './Form57InteractiveMaps'
  import Form58AbamaRequestReservation from './AbamaRequestReservation'

  import ConfirmDelete from '@/components/ConfirmDelete'
  import ComponentInLine from '../ComponentInLine'

  export default {
    name: 'content',
    components: {
      ConfirmDelete,
      FormTitle,
      Availability,
      FormSpace,
      FormImage,
      // SortContent,
      FormIframe,
      FormAlert,
      FormGallery,
      FormVideo,
      FormMeteo,
      FormMap,
      FormTwitter,
      FormFacebook,
      FormActivity,
      FormPdf,
      FormTimeline,
      FormText,
      FormContact,
      FormDivider,
      FormShow,
      FormSite,
      FormAgenda,
      FormParrilla,
      FormWifi,
      FormProperty,
      FormCommercial,
      FormQueue,
      FormFoodDrink,
      FormLinkDomain,
      FormForm,
      FormProductService,
      FormPdfTranslate,
      FormLinkExternal,
      FormChannelList,
      FormActivityActtiv,
      FormPoll,
      FormInstagram,
      FormIconList,
      ComponentInLine,
      FormDropdownButton,
      FormDfiles,
      FormRcovid,
      FormImageTranslate,
      FormIberostarFood,
      FormIcons,
      FormHsconsulting,
      FormBrochure,
      FormInfoten,
      FormCMActivities,
      Form49MenuExtFood,
      Form50CMAttendance,
      Form51CMWeeklyMenu,
      Form54FormCio,
      Form55DviewcontentMessages,
      Form56Servatur,
      Form57InteractiveMaps,
      Form58AbamaRequestReservation,
    },
    props: {
      content: {
        type: Object,
        required: true
      },
      onMoveDisabled: {
        type: Function,
        required: true
      },
      isMoveContent: {
        type: Boolean,
        required: false,
        default: false
      },
      scrollPosition: {
        type: String,
        required: false,
        default: null
      }
    },
    data: () => ({
      dialogInLinePos: null,
      showDialogInLine: false,
      showConfirmDelete: false,
      showCollapseContentInfo: false,
      showMenuList: false,
      menuToMove: null,
    }),
    computed: {
      ...mapState('app',['collapseContent', 'locale']),
      enterpriseColor () {
        return this.$store.state.app.enterpriseColor
      },
      menus () {
        return this.$store.state.app.menus.filter(x=> !x.IsMenuWithSubmenu).map(item => {
              // let name = utils.getTranslation (item.Name, this.locale)
              // name = item.Alias && item.Alias.length > 0 ? name.concat(' (',item.Alias,')') : name
              return ({
                ID: item.ID,
                Name: utils.getTranslation(item.Name, this.locale)
              })
            })
      }
    },
    mounted () {
      this.isExpand = []
      if(this.content.ID === this.scrollPosition) {
        setTimeout(() => { 
          const element = this.$refs[this.scrollPosition]
          const top = element.offsetParent.offsetTop

          window.scrollTo(0, top)
        }, 1000)   
      }
    },
    methods: {
      getIcon (type) {
        if (type === 2) {
          return 'mdi-page-layout-header'
        } else if (type === 3) {
          return 'mdi-arrow-expand-vertical'
        } else if (type === 4) {
          return 'mdi-image'
        } else if (type === 5) {
          return 'mdi-iframe'
        }
      },
      getTitle (type) {
        if (type === 2) {
          return 'menuType.title'
        } else if (type === 3) {
          return 'menuType.space'
        } else if (type === 4) {
          return 'menuType.image'
        } else if (type === 5) {
          return 'menuType.iframe'
        }
      },
      handleCancelDelete () {
        this.showConfirmDelete = false
      },
      handleHideContent() {
        this.content.HideMobile = this.content.HideMobile ? false : true
        const body = {
          HideMobile: this.content.HideMobile
        }
        api.updateItem('contents', this.content.ID.concat('/hide-content'), body)
          .then(response => {
            console.log(response)
          })
          .catch(error => {
            console.log('error', error)
          })
      },
      handleCopyContent () {
        const max = this.$store.state.app.contents.length > 0 ? this.$store.state.app.contents.reduce(function(prev, current) {
            return (prev.ORD > current.ORD) ? prev : current
        }) : 0
        const aux = JSON.parse(JSON.stringify(this.content))
        aux.ID = `new_${_.uniqueId()}`
        aux.ORD = max.ORD + 1
        aux.IsNew = true
        this.$store.state.app.contents.push(aux)
      },
      handleDelete() {
        if (this.content.IsNew) {
          // si es nuevo solo lo eliminamos de array temporal
          this.$store.state.app.contents = this.$store.state.app.contents.filter(x => x.ID !== this.content.ID)
        } else {
          // TODO pendiente de elimar de la base de datos
          api.deleteItem('contents', this.content.ID).then(response => {
            if (response.status === 200) this.$store.state.app.contents = this.$store.state.app.contents.filter(x => x.ID !== this.content.ID)
          })
        }
        this.showConfirmDelete = false
      },
      handleMoveContent(){
        if (this.menuToMove) {
          let aux = this.$store.state.app.contents.filter(x => x.MenuID = this.menuToMove)
          const max = aux.length > 0 ? aux.reduce(function(prev, current) {
            return (prev.ORD > current.ORD) ? prev : current
          }).ORD : 0
          
          aux = JSON.parse(JSON.stringify(this.$store.state.app.contents.filter(x => x.ID === this.content.ID)))
          this.$store.state.app.contents = this.$store.state.app.contents.filter(x => x.ID !== this.content.ID)
          if (aux > 0) {
            aux[0].MenuID = this.menuToMove
            aux[0].ORD = max + 1
            this.$store.state.app.contents.push(aux[0])
          }
          // console.log(this.content.ID, this.menuToMove)
          const body = {
            MenuID: this.menuToMove,
            ORD: max
          }
          api.updateItem('contents', this.content.ID.concat('/move'), body)
            .then(response => {    
              console.log(response)          
              this.$router.push(`/menus/${this.menuToMove}`)
              location.reload(true)
            })
            .catch(error => {
              console.log('error', error)
            })
          this.showMenuList = false
        }
      },
      handleUpdateAvailability (value) {
        this.content.IsTemp = value.isTemp
        this.content.Per = value.per
        this.content.DateStart = value.dateStart
        this.content.DateEnd = value.dateEnd
        this.content.TimeStart = value.timeStart
        this.content.TimeEnd = value.timeEnd
        this.content.IsAllTimes = value.isAllTimes
        this.content.IsAllDays = value.isAllDays
        this.content.Rec = value.rec
        this.content.DayOfWeek = value.dayOfWeek
        this.content.DayOfMonth = value.dayOfMonth
        this.content.Alt = value.alt
      }
    }
  }
</script>

<style scoped>
</style>

